<template lang="pug">
#app(v-if='usuarioLogado')
    menu-lateral(v-if='!embeddedMode', :botoes='botoes')

    menu-superior(
        v-if='!embeddedMode',
        :route='this.$route.name',
        :routeParams='this.$route.params',
        @updateAmbienteSelecionado='updateAmbienteSelecionado'
    )

    section.conteudo-central(:class='{ "embedded": embeddedMode }')
        router-view

    ExportarDocumentoVue
    ExportarDocumentoAnaliseCredito

    MonitorarProcessamentoVue
    Loading

login(v-else)
</template>

<script>
import Login from '@/views/Login';
import Loading from '@/components/Loading';
import MenuLateral from '@/components/layout/MenuLateral';
import MenuSuperior from '@/components/layout/MenuSuperior.vue';
import ExportarDocumentoVue from '@/components/diagnosticoSocioambiental/ExportarDocumento';
import ExportarDocumentoAnaliseCredito from '@/modules/pre-analise-credito/components/ExportarDocumentoAnaliseCredito.vue';
import MonitorarProcessamentoVue from '@/components/monitoramento/MonitorarProcessamento.vue';
import authService from '@/services/AuthService';
import controleAcesso from '@/utils/controleAcesso';
import { mapState, mapActions, mapGetters } from 'vuex';
import Temas from '@/utils/layouts/temas';

export default {
    name: 'app',
    components: {
        MenuSuperior,
        MenuLateral,
        Login,
        Loading,
        ExportarDocumentoVue,
        ExportarDocumentoAnaliseCredito,
        MonitorarProcessamentoVue
    },

    props: {
        keycloak: {}
    },
    data() {
        return {
            botoes: []
        };
    },
    created() {
        this.getUserPerfil();
        this.setTradingAsync();
    },
    computed: {
        ...mapState(['usuarioLogado']),
        ...mapGetters(['embeddedMode']),

        ano: function () {
            return new Date().getFullYear();
        }
    },
    methods: {
        ...mapActions(['setTrading']),

        async getUserPerfil() {
            try {
                const { data } = await authService.isLogged();
                // atributos do grupo
                Temas.aplicarTema(data.tema);
                document.title = data.title;
                document
                    .querySelector("[rel='icon']")
                    .setAttribute('href', data.faviconUrl);

                // roles
                this.botoes = controleAcesso.buscarPermissoesMenuFeature(data);

                // ROLE_VEGA_ADMIN
                if (data.isVegaAdmin) {
                    this.$router.push({ name: 'Relatorios' });
                    return;
                }

                // ROLE_ANALYST
                if (data.isAnalyst) {
                    this.$router.push({ name: 'Laudos' });
                    return;
                }
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível identificar o tipo de perfil'
                });
                this.keycloak.logout();
            }
        },

        async updateAmbienteSelecionado() {
            const { data } = await authService.isLogged();
            this.botoes = controleAcesso.buscarPermissoesMenuFeature(data);
        },

        async setTradingAsync() {
            setTimeout(_ => this.setTrading(), 500);
        }
    }
};
</script>

<style lang="scss">
#app {
    height: 100vh;
    width: 100vw;
    overflow: hidden;

    .conteudo-central {
        height: calc(100vh - 65px);
        width: calc(100vw - 70px);
        margin-top: 65px;
        margin-left: 70px;
        overflow-y: auto;

        &.embedded {
            height: 100vh;
            width: 100vw;
            margin-top: 0;
            margin-left: 0;
        }
    }

    /* width */
    ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        border-radius: 10px;
        background: var(--white);
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: var(--primary);
        border-radius: 10px;
        border: 1px solid var(--white);
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #b5b5b5;
    }

    @media (max-width: 1370px) {
        Footer#lyra-rodape {
            padding-top: 80px;
            margin: 0;

            p {
                width: 100%;
                text-align: center;
                margin-bottom: 0;
                margin-left: 70px;
            }
        }
    }
}
</style>
